import {permissionObj} from "../../../../../Helpers/permission";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import React from "react";
import {VISITOR_SUB_VIEW_MODEL} from "../../Invitation/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RequestInvitationHeader = (props) => {
    const {
        subView,
        handleSubViewChange,

        searchId,
        setBodyForExport,
        setSearchResults,
        searchElement,
        setSearchElement,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        setFinalArray,
        permission,
        DEV,
        viewType
    } = props;

    return(
            <div className={"d-flex"}>
                <div className='d-flex'>
                    {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_REQUEST_READ) ) &&
                    <ButtonAction
                        id='btn_rih_tab_request'
                        name={'requested_invitations'}
                        className={VISITOR_SUB_VIEW_MODEL.REQUESTS.REQUESTED_INVITATIONS === subView ? 'btn-outlined-secondary-600-100  mr-8px' : 'btn-outlined-secondary-600-00  mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => handleSubViewChange(VISITOR_SUB_VIEW_MODEL.REQUESTS.REQUESTED_INVITATIONS)}
                    />
                    }
                    {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_REQUEST_READ) ) &&
                    <ButtonAction
                        id='btn_rih_tab_status'
                        name={'invitation_status'}
                        className={VISITOR_SUB_VIEW_MODEL.REQUESTS.INVITATION_STATUS === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00  mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => handleSubViewChange(VISITOR_SUB_VIEW_MODEL.REQUESTS.INVITATION_STATUS)}
                    />
                    }

                </div>
                <div className='w-75 '>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        search={search}
                        setSearch={setSearch}
                        setFinalArray={setFinalArray}
                        contractorId={null}
                        supplierId={null}
                        viewType={viewType}
                    />
                </div>
            </div>
    )
}

export default RequestInvitationHeader
